/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import GlobalForm from "../../../components/globalForm/GlobalForm";
import Loading from "../../../components/shared/loading/Loading";
import { updateData } from "../../../hooks/update";
import useFetch from "../../../hooks/useFetch";
import { apiPath } from "../../../utility/Constant";

const BoardUniquePage = () => {
  const { boardApi } = apiPath;
  const [boardUniqueData, boardUniqueLoading] = useFetch(boardApi);
  const [filteredData, setFilteredData] = useState();
  let { id } = useParams();

  useEffect(() => {
    setFilteredData(boardUniqueData?.filter((item) => item._id === id)[0]);
  }, [boardUniqueData, id]);

  if (boardUniqueLoading || !filteredData?._id) {
    return <Loading />;
  }

  const { Position, Name, description, image, _id } = filteredData ?? {};

  const data = [
    {
      elementType: "input",
      label: "Name",
      type: "Text",
      name: "Name",
      defaultValue: Name,
      required: false,
    },
    {
      elementType: "input",
      label: "Position",
      type: "Text",
      name: "Position",
      defaultValue: Position,
      required: false,
    },
    {
      elementType: "textField",
      label: "description",
      type: "Text",
      name: "description",
      defaultValue: description,
      required: false,
    },
    {
      elementType: "file",
      label: `Image`,
      name: "image",
      type: "file",
      fullCol: true,
      defaultValue: image,
      required: false,
    },
  ];

  const update = (data) => {
    const { image, ...rest } = data;
    rest.image = {
      url: image,
    };
    updateData(boardApi, rest, _id);
    setTimeout(() => {
      window.location.reload();
    }, 800);
  };

  return (
    <div>
      <GlobalForm data={data} update={update} />
    </div>
  );
};

export default BoardUniquePage;
